// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__Z9nFz","footerRow":"Footer_footerRow__8M7iv"};